import { z } from 'zod';

export const billingSchema = z
  .object({
    breakBillingPolicy: z.string().optional(),
  })
  .passthrough()
  .superRefine((data, ctx) => {
    // Only validate if the field is present but falsy (mirrors: !== undefined && !breakBillingPolicy)
    if (data.breakBillingPolicy !== undefined && !data.breakBillingPolicy) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['breakBillingPolicy'],
        message: 'Please select a break billing policy',
      });
    }
  });

export type BillingSchemaData = z.infer<typeof billingSchema>;
